export const modelPositions = {
  back: {
    x: -4.387064103158292,
    y: 3.6432051132451,
    z: -249.938145671558
  },
  right: {
    x: -249.82530542034553,
    y: -4.7597012758366954,
    z: -8.041269513965343
  },
  front: {
    x: 1.4624917941275544,
    y: 2.3799584848944044,
    z: 125
  },
  left: {
    x: 249.7141197905644,
    y: 4.759701275836918,
    z: -10.96374119486817
  }
}

export const defaultLightSettings = {
  Ambient_Light: {
    color: '#FFFFFF', intensity: 0.7
  },
  Top_Light: {
    color: '#FFFFFF', intensity: 0,
    position: { x: -4, y: 100, z: -1 }
  },
  Left_Light: {
    color: '#FFFFFF', intensity: 0.3,
    position: { x: -100, y: 70, z: 64 }
  },
  Right_Light: {
    color: '#FFFFFF', intensity: 0.3,
    position: { x: 100, y: 84, z: 51 }
  },
  Back_Light: {
    color: '#FFFFFF', intensity: 0.4,
    position: { x: 0, y: 118, z: -75 }
  }
}

export const lightSettings = {
  Ambient_Light: { color: 0xDEDEDE, intensity: 0.8 },
  Top_Light: {
    color: 0xfafafa, intensity: 0.1,
    position: { x: -80, y: -80, z: -5 }
  },
  Left_Light: {
    color: 0xffffff, intensity: 0.2,
    position: { x: -80, y: 200, z: -5 }
  },
  Right_Light: {
    color: 0xffffff, intensity: 0.1,
    position: { x: 80, y: -80, z: -5 }
  },
  Back_Light: {
    color: 0xffffff, intensity: 0.1,
    position: { x: 80, y: 200, z: -5 }
  },
  Alpha: {
    type: "spot",
    color: 0xffffff, intensity: 1.5,
    position: { x: -100, y: 20, z: 150 },
    groundColor: 0x000000,
    distance: 250,
    angle: 50,
    penumbra: 1,
    decay: 1.5
  },
  Bravo: {
    type: "spot",
    color: 0xffffff, intensity: 1.5,
    position: { x: 100, y: 20, z: 150 },
    groundColor: 0x000000,
    distance: 250,
    angle: 50,
    penumbra: 1,
    decay: 1.5
  },
  Charlie: {
    type: "spot",
    color: 0xffffff, intensity: 1.5,
    position: { x: -100, y: 30, z: -150 },
    groundColor: 0x000000,
    distance: 250,
    angle: 50,
    penumbra: 1,
    decay: 1.5
  },
  Delta: {
    type: "spot",
    color: 0xffffff, intensity: 1.5,
    position: { x: 100, y: 30, z: -150 },
    groundColor: 0x000000,
    distance: 250,
    angle: 50,
    penumbra: 1,
    decay: 1.5
  }
}


// WEBPACK FOOTER //
// ./src/components/Render3D/config.js